/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const PersonalDetailsIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 34 24"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" strokeLinejoin="round">
      <path d="M0.666666667,0.666666667 L0.666666667,22 L6,22 L6,21 C6,19.7173333 7.04933333,18.6666667 8.33333333,18.6666667 C9.616,18.6666667 10.6666667,19.7173333 10.6666667,21 L10.6666667,22 L21.3333333,22 L21.3333333,21 C21.3333333,19.7173333 22.3826667,18.6666667 23.6666667,18.6666667 C24.9493333,18.6666667 26,19.7173333 26,21 L26,22 L31.3333333,22 L31.3333333,0.666666667 L0.666666667,0.666666667 Z" />
      <circle cx="9.33333333" cy="7.33333333" r="2.66666667" />
      <path d="M9.33333333,10 C6,10 4.66666667,12 4.66666667,14 L14,14 C14,12 12.6666667,10 9.33333333,10 Z" />
      <path d="M17.3333333,14 L28,14" />
      <path d="M17.3333333,11.3333333 L28,11.3333333" />
      <path d="M17.3333333,8.66666667 L28,8.66666667" />
      <path d="M17.3333333,6 L22.6666667,6" />
    </g>
  </svg>
);

export default PersonalDetailsIcon;
